import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import QRCode from 'qrcode'
import {
	Button,
	FloatLabelInput,
	Modal,
} from '@buildbox/components'
import {
	primaryDashboardButtonStyles,
	primaryInputStyles,
} from 'shared/styles/theme'
import {
	createStoreAisle,
	updateStoreAisle,
} from 'shared/services/storeAisle.service'
import cogoToast from 'cogo-toast'
import cogoDefaultOptions from 'shared/util/toaster'
import { IStoreAisle } from 'shared/interfaces/storeAisle'

import QRCodeIcon from '../../../assets/images/qr-code-icon.svg'

import { IProps } from './types'
import { Container } from './styles'
import { Link } from 'react-router-dom'
import routesEnum from 'modules/Routes/enum'

export default function ModalStoreAisle(props: IProps) {
	const { isActive, selectedStoreAisle, selectedRetail, closeModal } = props

	const retailId = selectedStoreAisle?.retail || selectedRetail?.value || ''
	const [name, setName] = useState('')
	const [description, setDescription] = useState('')
	const [qrCode, setQrCode] = useState('')
	const [isSubmiting, setIsSubmiting] = useState(false)
	const [isFormValid, setIsFormValid] = useState(false)

	function generateQRCode(storeAisle: IStoreAisle) {
		;(async () => {
			const qrCodeBase64 = await QRCode.toDataURL(
				JSON.stringify({
					storeAisleId: storeAisle._id,
					retailId,
				}),
			)

			setQrCode(qrCodeBase64)
		})()
	}

	function loadStoreAisleState() {
		if (!isActive) return

		if (selectedStoreAisle) {
			setName(selectedStoreAisle.name)
			setDescription(selectedStoreAisle.description)

			generateQRCode(selectedStoreAisle)
		}
	}

	function validateForm() {
		const isValid = !!retailId && !!name && !!description

		setIsFormValid(isValid)
	}

	function clearFiels() {
		setName('')
		setDescription('')
	}

	const onClose = useCallback(
		(refetchData: boolean = false) => {
			clearFiels()
			closeModal({ refetchData, retail: retailId })
		},
		[closeModal, retailId],
	)

	const handleChangeTitle = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setName(event.target.value)
		},
		[],
	)

	const handleChangeRedirectLink = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setDescription(event.target.value)
		},
		[],
	)

	const handleSubmit = useCallback(() => {
		;(async () => {
			if (!isFormValid) return

			try {
				setIsSubmiting(true)

				const storeAisleToSave = {
					...selectedStoreAisle,
					retail: retailId,
					name: name,
					description: description,
				}

				if (!selectedStoreAisle) {
					await createStoreAisle(storeAisleToSave)
				} else {
					await updateStoreAisle(storeAisleToSave)
				}

				cogoToast.success(
					'Área de Atendimento salva com sucesso!',
					cogoDefaultOptions,
				)
			} finally {
				setIsSubmiting(false)
				onClose(true)
			}
		})()
	}, [
		isFormValid,
		description,
		selectedStoreAisle,
		retailId,
		name,
		onClose,
	])

	useEffect(validateForm, [retailId, name, description])
	useEffect(loadStoreAisleState, [isActive, selectedStoreAisle])

	return (
		<Modal
			isActive={isActive}
			title={!selectedStoreAisle ? 'Nova Área' : 'Detalhes da Área'}
			onClose={() => onClose()}
			className='modal-store-aisle'
			size={600}
		>
			<Container>
				{selectedRetail && (
					<span className='retail-name'>{selectedRetail.label}</span>
				)}
				<div className='inputs-group'>
					<div className='input-container'>
						<FloatLabelInput
							{...primaryInputStyles}
							label='Nome da área'
							round
							id='title'
							onChange={handleChangeTitle}
							value={name}
							maxLength={50}
						/>
					</div>
					<div className='input-container'>
						<FloatLabelInput
							{...primaryInputStyles}
							label='Descrição'
							round
							id='email'
							onChange={handleChangeRedirectLink}
							value={description}
						/>
					</div>
					{selectedStoreAisle && (
						<div className='input-container'>
							<Link
								className='view-qr-code'
								to={`${routesEnum.QRCODE_PRINTING}?areaName=${selectedStoreAisle.name}&qrCode=${qrCode}`}
							>
								<img src={QRCodeIcon} alt='ìcone de QR Code' />
								<span>Visualizar QR Code</span>
							</Link>
						</div>
					)}
				</div>

				<Button
					{...primaryDashboardButtonStyles}
					className='submit-button'
					onClick={handleSubmit}
					disabled={isSubmiting || !isFormValid}
				>
					{!selectedStoreAisle ? 'Cadastrar' : 'Salvar'}
				</Button>
			</Container>
		</Modal>
	)
}
